import React, { useEffect, useState, useCallback } from 'react';
import api from '../lib/api';
import { PageHeader, Card, Modal } from '../components/ui';
import { Plus, Pencil, Trash2, Search } from 'lucide-react';

const tom = () => ({ type: 'kunde', navn: '', adresse: '', postnr: '', sted: '', orgnr: '', telefon: '', epost: '' });

const Kontakter = () => {
  const [type, setType] = useState('alle');
  const [sok, setSok] = useState('');
  const [liste, setListe] = useState(null);
  const [open, setOpen] = useState(false);
  const [redigerer, setRedigerer] = useState(null);
  const [skjema, setSkjema] = useState(tom());

  const last = useCallback(() => {
    api.get('/kontakter', { params: { type } }).then((r) => setListe(r.data));
  }, [type]);
  useEffect(() => { last(); }, [last]);

  const aapne = (k) => { setRedigerer(k); setSkjema(k ? { ...k } : tom()); setOpen(true); };
  const lagre = async () => {
    if (redigerer) await api.put(`/kontakter/${redigerer.id}`, skjema);
    else await api.post('/kontakter', skjema);
    setOpen(false); last();
  };
  const slett = async (k) => {
    if (!window.confirm(`Slett ${k.navn}?`)) return;
    await api.delete(`/kontakter/${k.id}`); last();
  };

  if (!liste) return <span className="fm-text-muted">Laster…</span>;

  return (
    <>
      <PageHeader
        title="Kontakter"
        actions={<button className="btn-primary" onClick={() => aapne(null)}><Plus size={14} /> Ny kontakt</button>}
      />
      <Card style={{ marginBottom: 12 }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
          <div style={{ position: 'relative', flex: '1 1 280px', minWidth: 220 }}>
            <Search size={14} style={{ position: 'absolute', left: 10, top: '50%',
                                       transform: 'translateY(-50%)', opacity: 0.55 }} />
            <input value={sok} onChange={(e) => setSok(e.target.value)}
                   placeholder="Søk navn, org.nr, e-post, by…"
                   style={{ paddingLeft: 32, width: '100%' }} />
          </div>
          <label style={{ margin: 0 }}>Filter:</label>
          <select value={type} onChange={(e) => setType(e.target.value)} style={{ width: 200 }}>
            <option value="alle">Alle</option>
            <option value="kunde">Kunder</option>
            <option value="leverandør">Leverandører</option>
          </select>
        </div>
      </Card>
      <Card style={{ padding: 0 }}>
        <table>
          <thead>
            <tr>
              <th>Type</th><th>Navn</th><th>Adresse</th><th>Org.nr</th><th>Telefon</th><th>E-post</th><th style={{ width: 80 }}></th>
            </tr>
          </thead>
          <tbody>
            {liste.length === 0 && (
              <tr><td colSpan={7} className="fm-text-muted" style={{ textAlign: 'center', padding: 20 }}>Ingen kontakter.</td></tr>
            )}
            {liste.filter((k) => {
              if (!sok.trim()) return true;
              const q = sok.toLowerCase();
              return [k.navn, k.orgnr, k.epost, k.telefon, k.sted, k.adresse, k.postnr]
                .some((v) => (v || '').toString().toLowerCase().includes(q));
            }).map((k) => (
              <tr key={k.id}>
                <td><span className={`badge ${k.type === 'kunde' ? 'badge-info' : 'badge-purple'}`}>{k.type}</span></td>
                <td>{k.navn}</td>
                <td>{[k.adresse, k.postnr, k.sted].filter(Boolean).join(', ')}</td>
                <td>{k.orgnr}</td>
                <td>{k.telefon}</td>
                <td>{k.epost}</td>
                <td>
                  <div className="flex" style={{ gap: 4 }}>
                    <button className="btn-ghost" onClick={() => aapne(k)}><Pencil size={12} /></button>
                    <button className="btn-ghost" onClick={() => slett(k)} style={{ color: 'var(--theme-danger)' }}><Trash2 size={12} /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>

      <Modal open={open} onClose={() => setOpen(false)} title={redigerer ? 'Rediger kontakt' : 'Ny kontakt'}
             footer={<>
               <button className="btn-ghost" onClick={() => setOpen(false)}>Avbryt</button>
               <button className="btn-primary" onClick={lagre}>Lagre</button>
             </>}>
        <div className="grid" style={{ gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <div>
            <label>Type</label>
            <select value={skjema.type} onChange={(e) => setSkjema({...skjema, type: e.target.value})}>
              <option value="kunde">Kunde</option>
              <option value="leverandør">Leverandør</option>
            </select>
          </div>
          <div><label>Navn *</label><input value={skjema.navn} onChange={(e) => setSkjema({...skjema, navn: e.target.value})} /></div>
          <div style={{ gridColumn: '1 / -1' }}><label>Adresse</label><input value={skjema.adresse} onChange={(e) => setSkjema({...skjema, adresse: e.target.value})} /></div>
          <div><label>Postnr</label><input value={skjema.postnr} onChange={(e) => setSkjema({...skjema, postnr: e.target.value})} /></div>
          <div><label>Sted</label><input value={skjema.sted} onChange={(e) => setSkjema({...skjema, sted: e.target.value})} /></div>
          <div><label>Org.nr</label><input value={skjema.orgnr} onChange={(e) => setSkjema({...skjema, orgnr: e.target.value})} /></div>
          <div><label>Telefon</label><input value={skjema.telefon} onChange={(e) => setSkjema({...skjema, telefon: e.target.value})} /></div>
          <div style={{ gridColumn: '1 / -1' }}><label>E-post</label><input type="email" value={skjema.epost} onChange={(e) => setSkjema({...skjema, epost: e.target.value})} /></div>
        </div>
      </Modal>
    </>
  );
};

export default Kontakter;
